import React, { useState } from 'react';
import { AlertTriangle, ChevronDown, Check } from 'lucide-react';

/**
 * DietVerificationBadge - Shows AI self-verification status for the meal plan.
 */
export const DietVerificationBadge = ({ verification }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    if (!verification) return null;

    const { philosophy, verified_compliant, flagged_ingredients, substitutions_made } = verification;

    return (
        <div
            onClick={() => setIsExpanded(!isExpanded)}
            className={`diet-verification-badge cursor-pointer ${verified_compliant ? 'verified' : 'warning'} ${isExpanded ? 'rounded-2xl' : 'rounded-full'}`}
        >
            <div className="flex items-center gap-3">
                <div className={`p-1 rounded-full ${verified_compliant ? 'bg-green-500/20 text-green-500' : 'bg-amber-500/20 text-amber-500'}`}>
                    {verified_compliant ? <Check className="w-3 h-3" /> : <AlertTriangle className="w-3 h-3" />}
                </div>

                <div className="flex flex-col">
                    <span className="text-[10px] uppercase font-black tracking-widest leading-none mb-0.5">
                        {philosophy}
                    </span>
                    <span className="text-[11px] font-bold leading-none">
                        {verified_compliant ? 'Verified Compliance' : 'Review Recommendations'}
                    </span>
                </div>

                {(flagged_ingredients?.length > 0 || substitutions_made?.length > 0) && (
                    <ChevronDown className={`w-3 h-3 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} />
                )}
            </div>

            {isExpanded && (flagged_ingredients?.length > 0 || substitutions_made?.length > 0) && (
                <div className="mt-3 pt-3 border-t border-[var(--glass-border)] space-y-2 animate-in fade-in slide-in-from-top-2 duration-300">
                    {flagged_ingredients.length > 0 && (
                        <div>
                            <span className="text-[9px] font-black uppercase tracking-widest text-[var(--text-secondary)]">Flags</span>
                            <div className="flex flex-wrap gap-1 mt-1">
                                {flagged_ingredients.map(ing => (
                                    <span key={ing} className="px-1.5 py-0.5 bg-rose-500/10 text-rose-500 rounded-md text-[9px] font-bold">
                                        {ing}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                    {substitutions_made.length > 0 && (
                        <div>
                            <span className="text-[9px] font-black uppercase tracking-widest text-[var(--text-secondary)]">Chef Substitutions</span>
                            <ul className="mt-1 space-y-1">
                                {substitutions_made.map((sub, idx) => (
                                    <li key={idx} className="text-[10px] font-medium italic text-[var(--text-secondary)] flex items-center gap-2">
                                        <div className="w-1 h-1 rounded-full bg-[var(--accent-color)]" />
                                        {sub}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
